import React from "react";
import {
    FiEdit2,
    FiEye,
    FiEyeOff,
    FiTrash2,
    FiRefreshCw,
} from "react-icons/fi";

const CriteriaTable = ({
    title,
    items,
    getTypeBadge,
    getStatusBadge,
    onEdit,
    onToggleVisibility,
    onDeactivate,
    onReactivate,
    onDelete,
}) => {
    return (
        <div className="mb-8 last:mb-0">
            <div className="mb-3 flex items-center gap-2">
                <div className="h-5 w-1 rounded-full bg-[#D4A017]" />
                <h3 className="text-base font-bold text-[#173B3A]">{title}</h3>
                <span className="text-xs text-gray-400">({items.length})</span>
            </div>

            <div className="overflow-x-auto rounded-xl border border-teal-100">
                <table className="w-full min-w-[700px] border-collapse text-right">
                    <thead>
                        <tr className="border-b border-teal-100 bg-teal-50/50">
                            <th className="px-4 py-3 text-sm font-semibold text-teal-900">عنوان</th>
                            <th className="px-4 py-3 text-sm font-semibold text-teal-900">نوع</th>
                            <th className="px-4 py-3 text-sm font-semibold text-teal-900">وضعیت</th>
                            <th className="px-4 py-3 text-sm font-semibold text-teal-900">مورد استفاده</th>
                            <th className="px-4 py-3 text-sm font-semibold text-teal-900">عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="px-4 py-8 text-center text-sm text-gray-400">
                                    هیچ معیاری برای این دسته تعریف نشده است.
                                </td>
                            </tr>
                        ) : (
                            items.map((item) => (
                                <tr
                                    key={item.id}
                                    className="border-b border-gray-100 last:border-b-0 transition hover:bg-teal-50/30"
                                >
                                    <td className="px-4 py-3 text-sm text-gray-700">{item.title}</td>
                                    <td className="px-4 py-3">{getTypeBadge(item.type)}</td>
                                    <td className="px-4 py-3">{getStatusBadge(item.status)}</td>
                                    <td className="px-4 py-3 text-sm text-gray-500">
                                        {item.usage.totalUsageCount?.toLocaleString("fa-IR") || 0} کسب‌وکار
                                    </td>
                                    <td className="px-4 py-3">
                                        <div className="flex flex-wrap justify-end gap-2">
                                            {item.status !== "inactive" && (
                                                <>
                                                    <button
                                                        onClick={() => onEdit(item)}
                                                        className="inline-flex items-center gap-1.5 rounded-lg border border-teal-200 bg-white px-3 py-1.5 text-xs font-medium text-teal-700 transition hover:border-teal-300 hover:bg-teal-50"
                                                    >
                                                        <FiEdit2 />
                                                        ویرایش
                                                    </button>

                                                    <button
                                                        onClick={() => onToggleVisibility(item)}
                                                        className="inline-flex items-center gap-1.5 rounded-lg border border-amber-200 bg-white px-3 py-1.5 text-xs font-medium text-amber-700 transition hover:border-amber-300 hover:bg-amber-50"
                                                    >
                                                        {item.status === "hidden" ? (
                                                            <>
                                                                <FiEye />
                                                                نمایان‌سازی
                                                            </>
                                                        ) : (
                                                            <>
                                                                <FiEyeOff />
                                                                مخفی‌سازی
                                                            </>
                                                        )}
                                                    </button>

                                                    <button
                                                        onClick={() => onDeactivate(item)}
                                                        disabled={item.usage.totalUsageCount > 0}
                                                        className="inline-flex items-center gap-1.5 rounded-lg border border-red-200 bg-white px-3 py-1.5 text-xs font-medium text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400"
                                                        title={
                                                            item.usage.totalUsageCount > 0
                                                                ? "در حال استفاده است"
                                                                : ""
                                                        }
                                                    >
                                                        <FiTrash2 />
                                                        غیرفعال‌سازی
                                                    </button>
                                                </>
                                            )}

                                            {item.status === "inactive" && (
                                                <>
                                                    <button
                                                        onClick={() => onReactivate(item)}
                                                        className="inline-flex items-center gap-1.5 rounded-lg border border-teal-200 bg-white px-3 py-1.5 text-xs font-medium text-teal-600 transition hover:border-teal-300 hover:bg-teal-50"
                                                    >
                                                        <FiRefreshCw />
                                                        فعال‌سازی
                                                    </button>

                                                    <button
                                                        onClick={() => onDelete(item)}
                                                        className="inline-flex items-center gap-1.5 rounded-lg border border-red-200 bg-white px-3 py-1.5 text-xs font-medium text-red-600 transition hover:border-red-300 hover:bg-red-50"
                                                    >
                                                        <FiTrash2 />
                                                        حذف کامل
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CriteriaTable;